export default __webpack_public_path__ + "static/media/global_icon.aee19ad9.svg";